import type React from 'react'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import Button from '@/components/Button'
import TextInput from '@/components/input/TextInput'
import { useValidEmail } from '@/hooks/hooks'

const Container = styled.div`
  display: grid;
  grid-template-columns: min-content min-content min-content;
  gap: 20px;
  justify-content: center;
`

interface OnClickSignupManually {
  emailAddress: string
  inviteCode: string
}

interface OnClickGmailSignup {
  inviteCode: string
}

interface Props {
  onClickSignupManually: ({ emailAddress, inviteCode }: OnClickSignupManually) => void
  onClickGmailSignup: ({ inviteCode }: OnClickGmailSignup) => void
}

const Signup: React.FC<Props> = ({ onClickSignupManually, onClickGmailSignup }) => {
  const [emailAddress, setEmailAddress] = useState('')
  const [inviteCode, setInviteCode] = useState('')

  const isValidEmail = useValidEmail(emailAddress)

  const params = new URLSearchParams(window.location.search)
  const inviteId = params.get('inviteId')

  useEffect(() => {
    if (inviteId) {
      setInviteCode(inviteId)
    }
  }, [inviteId, setInviteCode])

  return (
    <>
      <div>
        <TextInput
          value={emailAddress}
          type="email"
          label="Email Address"
          onChange={(e: any) => setEmailAddress(e.target.value)}
        />
        <TextInput
          value={inviteCode}
          type="text"
          label="Invite Code"
          onChange={(e: any) => setInviteCode(e.target.value)}
        />
      </div>
      <Container>
        <Button
          disabled={!isValidEmail}
          onClick={() => onClickSignupManually({ emailAddress, inviteCode })}
        >
          Sign Up Manually
        </Button>
        <Button onClick={() => onClickGmailSignup({ inviteCode })}>
          <div className="side-by-side-flex-center">
            Sign up with{' '}
            <img
              src="/assets/svg/gmail.svg"
              alt="gmail icon"
              style={{
                maxWidth: 30,
              }}
            />
          </div>
        </Button>
      </Container>
    </>
  )
}

export default Signup
